module.exports = __webpack_public_path__ + "static/img/39-2.57e189e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/39-2.jpg
// module id = VEcJ
// module chunks = 0